import type { Locale } from "@/lib/i18n";
import { pl, type CEventsCalendarTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cEventsCalendarTranslations: Record<Locale, CEventsCalendarTranslations> = {
  pl,
  en,
  de,
};

export type { CEventsCalendarTranslations };
